import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import config from '../../../../config';
import DossierCountrySelector from '../../dossierCountrySelector';
import Count from './count';
import DossierState from './dossierState';
import Documents from './documents';

function SubcontractorsStatsView(props) {
  const countries = Object.keys(props.statDossierState.values);

  return (
    <>
      {config.featureFlags.showGlobalKPIs &&
        <div className="flex-container space-between mb-5">
          <h1 className="mb-0"><Translate value="subcontractor.mySubcontractors"/></h1>
          {countries.length > 1 &&
            <DossierCountrySelector
              onChange={props.onCountryChange}
              value={props.selectedCountry || ''}
              countries={countries}
            />
          }
        </div>
      }
      <div className="row-eq-height">
        <div className="col-12 col-md-6">
          <Count
            count={props.statCount.value}
            loading={props.statCount.loading}
          />
        </div>
        {config.featureFlags.showGlobalKPIs &&
          <div className="col-12 col-md-6">
            <DossierState
              percentage={props.selectedCountry ? props.statDossierState.values[props.selectedCountry] : 0}
              loading={props.statDossierState.loading}
              error={props.statDossierState.error}
            />
          </div>
        }
      </div>
      {config.featureFlags.showGlobalKPIs &&
        <>
          <div className="row">
            <div className="col-12">
              <Documents
                percentages={props.statDocuments.values}
                loading={props.statDocuments.loading}
                error={props.statDocuments.error}
              />
            </div>
          </div>
        </>
      }
    </>
  );
}

SubcontractorsStatsView.propTypes = {
  onCountryChange: PropTypes.func.isRequired,
  selectedCountry: PropTypes.string,
  statCount: PropTypes.object.isRequired,
  statDossierState: PropTypes.object.isRequired,
  statDocuments: PropTypes.object.isRequired
};

export default SubcontractorsStatsView;
